var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.45C12.1333 9.45 12.2583 9.47083 12.375 9.5125C12.4916 9.55417 12.6 9.625 12.7 9.725L17.3 14.325C17.4833 14.5083 17.575 14.7417 17.575 15.025C17.575 15.3083 17.4833 15.5417 17.3 15.725C17.1166 15.9083 16.8833 16 16.6 16C16.3166 16 16.0833 15.9083 15.9 15.725L12 11.825L8.09995 15.725C7.91662 15.9083 7.68328 16 7.39995 16C7.11662 16 6.88328 15.9083 6.69995 15.725C6.51662 15.5417 6.42495 15.3083 6.42495 15.025C6.42495 14.7417 6.51662 14.5083 6.69995 14.325L11.3 9.725C11.4 9.625 11.5083 9.55417 11.625 9.5125C11.7416 9.47083 11.8666 9.45 12 9.45Z",
    fill: "#1C2227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandUp);
export default __webpack_public_path__ + "static/media/expand_up.4814c19c23ac9db2c738af5db06e36a0.svg";
export { ForwardRef as ReactComponent };